import React, { useEffect, useRef, useState } from 'react';
import GetDiagnosisData from "../../services/general/getDiagnosisData.api";
import ModifyPatientHistory from "../../services/general/modifyPatientHistory.api";
import { CBadge, CButton, CCol, CContainer, CModal, CModalBody, CModalFooter, CModalHeader, CModalTitle } from '@coreui/react';
import HighlightedText from './HighlightedText';
import ModifyPatientMap from '../../services/general/modifyPatientMap.api';
import { X } from 'lucide-react';

const GetDiagnosisHighlights = ({ patientID,noteStructureRef,diagnosis,alsoRunThisWhenDiagnosisAdd,removeDiagnosisIdFromNote,showOnlyNoteDiagnosis,addDiagnosisIdsToNote,getData,showCustomButton=false,textButtonForAddDiagnosis,customButtonClick,toggleItsModalWhenCustomButton=false, textInput,customButtonText, setDiagnosisAddedPinger }) => {
    const [patientDiagnosis, setPatientDiagnosis] = useState([]);
    const [allDiagnosisList, setAllDiagnosisList] = useState([]);
    const [allKeywords, setAllKeywords] = useState([]);
    const [modalVisible, setModalVisible] = useState(false);
    const [possibleDiagnosis, setPossibleDiagnosis] = useState([]);
    const [filterDiagnosisNew, setFilterDiagnosisNew] = useState([]);

    const onResetClose = () => {
        setModalVisible(false);
    };

    const getDiagnosisAll = async () => {
        let diagnosisData = await GetDiagnosisData();
        let tempData = JSON.parse(diagnosisData.d)?.Data;
        const allDiagnosisList = tempData.map(item => item.Name);
        const allDiagnosisListKeywords = tempData.map(item => item.Keywords.split(',')).flat().filter((keyword, index, self) => keyword && self.indexOf(keyword) === index);
        setAllKeywords(allDiagnosisListKeywords);
        setAllDiagnosisList(tempData);
    };

    const filterDiagnosisExceptAlreadyPresent = async () => {
        let diagnosisData = await GetDiagnosisData();
        let tempData = JSON.parse(diagnosisData.d)?.Data;
        const allDiagnosisListExceptAlreadyAdded = tempData.filter(dig =>
            !diagnosis.map(pd => pd.trim()).includes(dig.Name.trim())
        );
        setFilterDiagnosisNew(allDiagnosisListExceptAlreadyAdded);
    };

    const updatePatientDiagnosis = async (patientID, diagnosis) => {
        const newDiagnosis = possibleDiagnosis.map(item => item.Name.trim())
        if (newDiagnosis.length > 0) {
            let joinedDiagnosis = [...diagnosis, ...newDiagnosis]
            joinedDiagnosis = joinedDiagnosis.join(",")
            await ModifyPatientMap("UPDATE", patientID, joinedDiagnosis)
            await getPatientDiagnosis()
        }
    }

    const addDiagnosis = async() => {
        let newDiagnosis = possibleDiagnosis.map(obj => {
            return obj.Name.trim();
        });
        let allDiagnosisIdsToAdd = possibleDiagnosis.map(item=>item.id)
        newDiagnosis = newDiagnosis.join(',');
        updatePatientDiagnosis(patientID, newDiagnosis);
        if(addDiagnosisIdsToNote){addDiagnosisIdsToNote(allDiagnosisIdsToAdd) }
        if(alsoRunThisWhenDiagnosisAdd){
            alsoRunThisWhenDiagnosisAdd();
        }
        setModalVisible(false)
        setDiagnosisAddedPinger(p => !p)
        if(getData){await getData()}
    };

    useEffect(() => {
        getDiagnosisAll();
        getPatientDiagnosis();
    }, []);

    const getPatientDiagnosis = async () => {
        let diagnosisData = await ModifyPatientMap("GETALL", patientID, "");
        let tempData = JSON.parse(diagnosisData.d)?.Data;
        diagnosisData = tempData.filter(obj => obj.PatientID === patientID);
        let patientD = [];
        try {
            patientD = diagnosisData[0]?.Diagnosis?.split(',') || [];
        } catch (e) {
        }
        setPatientDiagnosis(patientD);
    };

    useEffect(() => {
        if (textInput) {
            filterDiagnosis();
        }
    }, [textInput, filterDiagnosisNew, allKeywords]);

    const detectedKeywordsRef = useRef(new Set());

    const filterDiagnosis = () => {
        const sanitizedImpression = textInput.replace(/[^a-zA-Z0-9\s]/g, '');

        const inputKeywords = sanitizedImpression.toLowerCase().split(/\s+/).filter(keyword => keyword.trim() !== '');
        detectedKeywordsRef.current.clear();

        const possibleDiagnosis = filterDiagnosisNew.filter(diagnosis => {
            const diagnosisKeywords = (diagnosis.Keywords || '').split(',').map(keyword => keyword.trim().toLowerCase());
            let match = true;

            diagnosisKeywords.find((diagnosisKeyword) => {
                match = true
                const diagnosisKeywordParts = diagnosisKeyword.split(/\s+/);
                if (diagnosisKeywordParts.length > 1) {
                    let foundIndex = inputKeywords.indexOf(diagnosisKeywordParts[0]);
                    if (foundIndex !== -1) {
                        for (let i = 0; i < diagnosisKeywordParts.length; i++) {
                            if (inputKeywords.length < foundIndex + i) {
                                match = false;
                                break;
                            }
                            if (diagnosisKeywordParts[i] !== inputKeywords[foundIndex + i]) {
                                match = false;
                                break;
                            }
                        }
                    } else {
                        match = false;
                    }
                } else {
                    let foundKeyword = inputKeywords.includes(diagnosisKeyword);
                    if (!foundKeyword) {
                        match = false;
                    } else {
                        match = true;
                    }
                }
                if (match) {
                    return true;
                }
            });
            if (match) {
                diagnosisKeywords.forEach(keyword => detectedKeywordsRef.current.add(keyword));
            }
            return match;
        });

        setPossibleDiagnosis(possibleDiagnosis);
    };

    const handleDeletePossibleValues = (idxx) => {
        const possibleValuesFlterd = possibleDiagnosis.filter((_, idx) => { return idx !== Number(idxx) })
        setPossibleDiagnosis(possibleValuesFlterd)
    }

    return (
        <div>
            <CButton onClick={() => { 
                setModalVisible(p => !p)
                filterDiagnosisExceptAlreadyPresent()
             }} variant='outline' color='success'>Get Diagnosis</CButton>
            <CModal
                className="dashboard-dark-modal patient-theme-modal patient-labs-modal"
                visible={modalVisible}
                scrollable={true}
                size='lg'
                onClose={onResetClose}
            >
                <CModalHeader>
                    <CModalTitle>Diagnosis Details</CModalTitle>
                </CModalHeader>
                <CModalBody className='d-flex'>
                    <div className='d-flex w-100'>
                        <div style={{maxWidth:"50%" ,width:"50%"}} className="flex-fill me-3 text-display">
                            <p style={{ whiteSpace: 'pre-line' }}></p>
                            <HighlightedText text={textInput} keywords={Array.from(detectedKeywordsRef.current)}></HighlightedText>
                        </div>
                        <hr />
                        <div className="flex-fill">
                            <h5>Detected Diagnosis</h5>
                            {possibleDiagnosis.map((diagnosis, index) => (
                                <CBadge key={index} color="info" className="d-flex align-items-center gap-2 me-2 mr-1 mb-1 text-white" style={{ cursor: 'pointer',width: 'fit-content', maxWidth: '100%'  }}>
                                    {diagnosis.Name}
                                    <X onClick={() => { handleDeletePossibleValues(index) }}  size={15} />
                                </CBadge>
                            ))}
                            <hr />
                            <h5>Existing Diagnosis</h5>
                            {diagnosis.map((diagnosisItem, index) => (
                                <CBadge
                                style={{
                                    cursor: 'pointer',
                                }}
                                onClick={()=>{
                                    removeDiagnosisIdFromNote(diagnosisItem)
                                }}
                                key={index} color="primary" className="me-2 mr-1 mb-1 text-white">
                                    {diagnosisItem}
                                    <span><X size={15} /></span>
                                </CBadge>
                            ))}
                        </div>
                    </div>
                </CModalBody>
                <CModalFooter>
                    <CButton variant='outline' color="secondary" onClick={onResetClose}>Close</CButton>
                    {showCustomButton && <CButton variant='outline' color="primary" onClick={
                     () => {
                         if(toggleItsModalWhenCustomButton){
                             setModalVisible(false)
                         }
                         customButtonClick()
                     }
                    }>{customButtonText}</CButton>}
                    <CButton color="primary" onClick={() => {
                        addDiagnosis()
                    }}>{textButtonForAddDiagnosis || "Add Detected Diagnosis"}</CButton>
                </CModalFooter>
            </CModal>
        </div>
    );
};

export default GetDiagnosisHighlights;
